export function Modal () {
  const buttons = Array.from(document.querySelectorAll('[data-toggle="modal"]',),);
  const $body = document.querySelector('body',);

  buttons.forEach(($button,) => {
    $button.addEventListener('click', (e,) => {
      e.preventDefault();
      const { target, } = $button.dataset;
      const href = $button.getAttribute('href',);
      const id = href ? href.substring(1,) : target;
      const $el = document.getElementById(id,);

      if ($el) {
        $el.classList.toggle('modal--active',);
        $body.classList.toggle('modal-open',);
      }
    },);
  },);

  const closeOnOutsideClick = buttons.some((button,) => button.hasAttribute('data-close="inside"',),);

  if (!closeOnOutsideClick) {
    const modals = Array.from(document.querySelectorAll('.modal',),);

    modals.forEach(($modal,) => {
      $modal.addEventListener('click', (e,) => {
        if (e.target === $modal) {
          closeModal($modal,);
        }
      },);

      document.addEventListener('keydown', (e,) => {
        if (e.key === 'Escape') {
          closeModal($modal,);
        }
      },);
    },);
  }

  function closeModal ($modal,) {
    $modal.classList.remove('modal--active',);
    $body.classList.remove('modal-open',);
  }
}
